// import { createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

export const dataApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getData: builder.mutation({
      query: (queryBody) => ({
        url: `/table/getQueryData`,
        method: "POST",
        body: queryBody,
      }),
      providesTags: ["Data"],
    }),
    getSqlQuery: builder.mutation({
      query: (queryBody) => ({
        url: `/table/getSqlQuery`,
        method: "POST",
        body: queryBody,
      }),
      providesTags: ["Data"],
    }),
    getColumnNames: builder.query({
      query: (dataSourceID) => ({
        url: "/table/getMongoColumns",
        params: {
          mongoId: dataSourceID,
        },
      }),
      providesTags: ["ColumnsList"],
    }),
    getSerachColumns: builder.query({
      query: ({ dataSourceID, value, workbookId }) => {
        return {
          url: "/search/searchColumns",
          params: {
            dataSourceID: dataSourceID,
            columnName: value,
            workbookID: workbookId, // Add workbookID to the params
          },
        };
      },
    }),
    getFiltersOptions: builder.mutation({
      query: ({ filterBody, calledFrom }) => {
        // console.log(filterBody);
        // console.log(calledFrom);
        return {
          url: `/table/getfiltervalues`,
          method: "POST",
          body: filterBody,
        };
      },
    }),
    getFolder: builder.query({
      query: (folderId) => ({
        url: "/api/folderPath",
        params: {
          folderId: folderId,
        },
      }),
    }),
    updateSheet: builder.mutation({
      query: ({ sheet, workbookID }) => ({
        url: `workbookapi/updateSheet`,
        method: "PUT",
        body: { sheet, workbookID },
      }),
    }),
    patchCommonFiters: builder.mutation({
      query: ({ _id, commonFilters }) => ({
        url: `workbookapi/patchWorkbook`,
        method: "PUT",
        body: { _id, commonFilters },
      }),
    }),
    publishWorkbook: builder.mutation({
      query: ({
        draftId,
        icon,
        name,
        commonFilters,
        hierarchy,
        calculatedFields,
        folderId,
        sheets,
        selectedSheetId,
        dataSources,
      }) => {
        // Log the payload to the console
        // console.log("Publishing Workbook:", {
        //   draftId,
        //   icon,
        //   name,
        //   calculatedFields,
        //   commonFilters,
        //   hierarchy,
        //   folderId,
        //   sheets,
        //   selectedSheetId,
        //   dataSources,
        // });

        return {
          url: "workbookapi/publishas",
          method: "POST",
          body: {
            draftId,
            icon,
            name,
            commonFilters,
            hierarchy,
            calculatedFields,
            folderId,
            sheets,
            selectedSheetId,
            dataSources,
          },
        };
      },
    }),
    patchWorkbook: builder.mutation({
      query: (props) => {
        // console.log(props);

        const { workbookId, workbookData, sheetsData } = props;

        // console.log(workbookId);
        return {
          url: "workbookapi/workbook-and-sheet", // Verify this URL is correct
          method: "PATCH", // Ensure the method is PATCH
          body: {
            workbookId,
            workbookData,
            sheetsData,
          },
        };
      },
    }),
    getWorkbook: builder.query({
      query: ({ workbookId, viewId }) => {
        // console.log({ workbookId, viewId });
        return {
          url: "workbookapi/workbooks/Id",
          params: {
            workbookId: workbookId,
            viewId: viewId,
          },
        };
      },
      transformResponse: (response) => {
        // Modify the sheets to replace _id with id
        return {
          ...response,
          sheets: response.sheets.map((sheet) => ({
            ...sheet,
            ID: sheet._id,
            _id: undefined,
          })),
        };
      },
    }),
    deleteSheet: builder.mutation({
      query: (sheetId) => {
        // console.log(sheetId);
        return {
          url: `workbookapi/deleteSheet`,
          method: "DELETE",
          body: sheetId,
        };
      },
    }),
    renameColumn: builder.mutation({
      query: (requiredObject) => ({
        url: "workbookapi/renameCoulumn", // Ensure this URL is correct
        method: "PUT",
        body: requiredObject,
      }),
      invalidatesTags: ["ColumnsList"],
    }),
    updateCalculatedField: builder.mutation({
      query: ({ workbookId, calculatedFieldId, updatedFieldData }) => ({
        url: `workbookapi/updateCalculatedField`,
        method: "PATCH",
        body: {
          workbookId,
          calculatedFieldId,
          updatedFieldData,
        },
      }),
    }),
    // Added API for deleting a column or calculated field
    deleteColumnOrCalculatedField: builder.mutation({
      query: (body) => ({
        url: "workbookapi/deleteColumnOrCalculatedField",
        method: "DELETE",
        body: body,
      }),
    }),
    //Added Api for integrating Tauu in Aside3
    getVizardData: builder.mutation({
      query: (body) => ({
        url: "/vizard/unique-values",
        method: "POST",
        body: body,
      }),
    }),
    updateWorkbook: builder.mutation({
      query: (body) => {
        // console.log(body);
        return {
          url: "workbookapi/patchWorkbook",
          method: "PATCH",
          body: body,
        };
      },
    }),
    //uploadimage
    uploadCloudImage: builder.mutation({
      query: (formData) => {
        // console.log(formData); // Debugging log
        return {
          url: "/cloudinary/upload",
          method: "POST",
          body: formData, // Ensure FormData is passed correctly
        };
      },
      transformResponse: (response) => response.images,
    }),
    screenshotFunction: builder.mutation({
      query: (body) => {
        return {
          url: "/email/screenshot",
          method: "POST",
          body: body,
        };
      },
    }),
    saveWorkbookView: builder.mutation({
      query: (object) => {
        // console.log(object);
        return {
          url: "/workbookapi/saveWorkbookView",
          method: "POST",
          body: object,
        };
      },
    }),
    getWorkbookViewsByWorkbookId: builder.query({
      query: (workbookId) => ({
        url: "/workbookapi/getWorkbookViewsByWorkbookId/id",
        params: {
          workbookId: workbookId,
        },
      }),
    }),
    deleteWorkbookView: builder.mutation({
      query: (body) => ({
        url: "/workbookapi/deleteWorkbookView",
        method: "DELETE",
        body: body,
      }),
    }),
    searchFilterValues: builder.mutation({
      query: (body) => ({
        url: "/table/searchFilterValues",
        method: "POST",
        body: body,
      }),
    })
  }),
});

export const {
  useGetDataMutation,
  useGetColumnNamesQuery,
  useGetSerachColumnsQuery,
  useGetFiltersOptionsMutation,
  useGetFolderQuery,
  useUpdateSheetMutation,
  usePatchCommonFitersMutation,
  usePublishWorkbookMutation,
  usePatchWorkbookMutation,
  useGetWorkbookQuery,
  useDeleteSheetMutation,
  useRenameColumnMutation,
  useUpdateCalculatedFieldMutation,
  useDeleteColumnOrCalculatedFieldMutation,
  useGetVizardDataMutation,
  useUpdateWorkbookMutation,
  useUploadCloudImageMutation,
  useScreenshotFunctionMutation,
  useSaveWorkbookViewMutation,
  useGetWorkbookViewsByWorkbookIdQuery,
  useDeleteWorkbookViewMutation,
  useGetSqlQueryMutation,
  useSearchFilterValuesMutation
} = dataApiSlice;
